// Autogenerated file
export const moduleTypesEnum = {
    Exploitation: "Exploitation",
    Refueling: "Refueling",
    Logistic: "Logistic",
    CrStart: "CrStart",
};
export const moduleTypes = [
    { label: "Эксплуатация", value: "Exploitation" },
    { label: "Топливное планирование", value: "Refueling" },
    { label: "Логистика", value: "Logistic" },
    { label: "CrStart", value: "CrStart" },
];
